import { useHistory } from 'react-router-dom';
import {
  BuyMoreSaveMore,
  ImproveHealth,
  WasteLessFood,
} from '@hungryroot/icons';
import { Button, Dimension, Heading, Paragraph } from '@hungryroot/ramen';
import { BreakpointSizeMedium } from '@hungryroot/tokens';
import { Footer } from '../Footer/Footer';
import styles from './FoodPreferencesIntro.module.css';

interface Props {
  testid?: string;
  next: string | null;
  prev: string | null;
}

export function FoodPreferencesIntro({ testid, next, prev }: Props) {
  const history = useHistory();

  return (
    <div data-testid={testid} className={styles.container}>
      <picture className={styles.picture}>
        <source
          srcSet="/public/img/quiz/foodPreferencesIntroDesktop1x.png 1x, /public/img/quiz/foodPreferencesIntroDesktop2x.png 2x"
          media={`(min-width: ${BreakpointSizeMedium})`}
          width={2017}
          height={1255}
        />
        <img
          srcSet="/public/img/quiz/foodPreferencesIntroMobile1x.png 1x, /public/img/quiz/foodPreferencesIntroMobile2x.png 2x"
          src="/public/img/quiz/foodPreferencesIntroMobile1x.png"
          alt=""
          width={800}
          height={1200}
        />
      </picture>
      <div className={styles.content}>
        <Heading variant="HeroAlt" className={styles.heading}>
          Next, tell us what looks good
        </Heading>
        <ul className={styles.list}>
          <li className={styles.item}>
            <WasteLessFood className={styles.icon} />
            <Paragraph variant="lead">
              We’ve curated options for you from over 15,000+ groceries and
              recipes.
            </Paragraph>
          </li>
          <li className={styles.item}>
            <ImproveHealth className={styles.icon} />
            <Paragraph variant="lead">
              Your selections allow us to better tailor our recommendations.
            </Paragraph>
          </li>
          <li className={styles.item}>
            <BuyMoreSaveMore className={styles.icon} />
            <Paragraph variant="lead">
              You can shop our full catalog after checkout.
            </Paragraph>
          </li>
        </ul>
      </div>
      <Dimension
        level="four"
        as={Footer}
        className={styles.footer}
        backButton={
          prev !== null && (
            <Button
              onClick={(e) => {
                e.preventDefault();
                history.push(prev);
              }}
              style="accent"
              accentColor="avocado"
              size="medium"
              prominence="secondary"
              textPrimary="Back"
            />
          )
        }
        submitButton={
          <Button
            buttonType="submit"
            testid="quiz-button-next"
            onClick={() => {
              if (next !== null) {
                history.push(next);
              }
            }}
            style="accent"
            accentColor="avocado"
            size="medium"
            prominence="primary"
            textPrimary="Continue"
          />
        }
      />
    </div>
  );
}
